<template>
  <div class="flex flex-wrap gap-5">
    <aside
      class="w-full md:w-60 h-fit sticky md:fixed bg-white p-5 rounded-md shadow-md border-b-2 border-h-primary-500 select-none"
    >
      <p class="text-lg font-bold truncate capitalize">
        <i
          class="pi pi-arrow-left cursor-pointer hover:bg-h-primary-500 hover:text-white transition-all p-1 rounded-full"
          @click.prevent="$router.go(-1)"
        />
        {{ list.title }}
      </p>
      <ul v-for="(link, i) in list.links" :key="i" class="my-2">
        <li
          :id="link.linkId"
          :class="`cursor-pointer transition-all hover:scale-95 text-h-primary-500 py-1 pl-3 ${
            selected.linkId === link.linkId
              ? 'bg-h-secondary-50 border-l-4 border-h-secondary-600'
              : ''
          }`"
          @click="scrollMeTo(link.linkId, i)"
        >
          {{ link.name }}
        </li>
      </ul>
    </aside>

    <main class="flex flex-col w-full md:ml-64 gap-5">
      <div
        class="px-10 h-52 rounded-md shadow-md flex items-center text-white gap-14 bg-no-repeat bg-cover bg-center"
        :style="bgImage(banner?.background)"
      >
        <img :src="banner?.icon" class="w-32 h-auto" />
        <h2 class="font-bold">{{ banner?.title }}</h2>
      </div>

      <div class="flex flex-col gap-8">
        <slot name="content"></slot>
      </div>
    </main>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

type Banner = {
  icon: String;
  background: String;
  title: String;
};

type Links = {
  title: String;
  links: any[];
};

export default defineComponent({
  name: "gridLayout",
  emits: ["onScroll"],
  props: {
    list: {
      type: Object as PropType<Links>,
      required: true,
      default: {} as Links,
    } as any,
    banner: {
      type: Object as PropType<Banner>,
      required: true,
      default: {} as Banner,
    } as any,
  },
  data() {
    return {
      selected: this.list.links[0],
    };
  },
  methods: {
    bgImage(image: string): any {
      return {
        "background-image": `url(${image})`,
      };
    },
    scrollMeTo(refName: any, index: any): void {
      this.selected = this.list.links[index];
      this.$emit("onScroll", refName);
    },
  },
});
</script>
